// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CreateSocialItem-cls1__e3248754ebde09dbe74e{/*!*/}.CreateSocialItem-cls2___3b387ad8663adccd3e0{display:flex;align-items:center}.CreateSocialItem-cls2___3b387ad8663adccd3e0.CreateSocialItem-spaced___a796aab20915947b125{justify-content:space-between}@media(min-width: 768px){.CreateSocialItem-cls2___3b387ad8663adccd3e0{grid-gap:8px;gap:8px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CreateSocialItem-cls1__e3248754ebde09dbe74e",
	"cls2": "CreateSocialItem-cls2___3b387ad8663adccd3e0 CreateSocialItem-cls1__e3248754ebde09dbe74e",
	"spaced": "CreateSocialItem-spaced___a796aab20915947b125"
};
export default ___CSS_LOADER_EXPORT___;
